import { CSSProperties, SVGProps } from 'react';

interface EvenPlatformIconProps extends SVGProps<SVGSVGElement> {
    className?: string;
    style?: CSSProperties;
    color?: string;
    size?: number;
    onClick?: () => void;
}

const EvenPlatformIcon = ({
    className,
    style,
    color,
    size = 52,
    onClick,
}: EvenPlatformIconProps) => (
    <svg
        className={className}
        style={style}
        width={size}
        height={size * (40 / 92)}
        onClick={onClick}
        viewBox="0 0 92 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M28.7781 15.4051V11.7074H17.5V27.7926H28.7781V24.2797H21.9373V21.1367H28.2235V17.8087H21.9373V15.4051H28.7781Z"
            stroke={color}
            strokeWidth="0.924437"
            strokeLinejoin="round"
        />
        <path
            d="M58.1752 15.4051V11.7074H46.8971V27.7926H58.1752V24.2797H51.3344V21.1367H57.6206V17.8087H51.3344V15.4051H58.1752Z"
            stroke={color}
            strokeWidth="0.924437"
            strokeLinejoin="round"
        />
        <path
            d="M35.0643 11.7074H29.8875L35.0643 27.6077H40.6109L45.6029 11.7074H40.7958L37.8376 22.8006L35.0643 11.7074Z"
            stroke={color}
            strokeWidth="0.924437"
            strokeLinejoin="round"
        />
        <path
            d="M65.3858 11.7074H60.5787V27.6077H64.8311V18.1785L70.1929 27.6077H75V11.7074H70.5627V20.9518L65.3858 11.7074Z"
            stroke={color}
            strokeWidth="0.924437"
            strokeLinejoin="round"
        />
    </svg>
)

export default EvenPlatformIcon;
